module.exports = "/_next/static/images/cpp-logo-77a19cdaf162711b871eb1014a86c0b5.png";